import { Component, OnInit } from '@angular/core';
import { PlatformAppContext } from '@/app/platform/platform-context/platform-app-context';

@Component({
    selector: 'egi-app-editor-page',
    templateUrl: './egi-app-editor-page.component.html',
    styleUrls: ['./egi-app-editor-page.component.css'],
    standalone: false
})
export class EgiAppEditorPageComponent implements OnInit {
  constructor(readonly egiAppContext: PlatformAppContext) {}

  ngOnInit(): void {}
}
